import script from "./Protocol.vue?vue&type=script&setup=true&lang=js"
export * from "./Protocol.vue?vue&type=script&setup=true&lang=js"

import "./Protocol.vue?vue&type=style&index=0&id=a4ab6558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ab6558"]])

export default __exports__